import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/signature.scss";
import React from "react";

const NavObject = ({
  object,
  active,
  text,
  src,
  setOpen,
  setObject,
  hidden,
  setHidden,
  setActive,
  setOpenSignIn,
  userSliceState,
  condition,
}) => {
  const NavigateObject = (object, setModal, setObject, condition = false) => {
    if (active === object) {
      setHidden(!hidden);
      setModal(false);
      setActive("");
    } else {
      if (!condition) {
        setHidden(false);
        setActive(setObject);
        setModal(true);
      } else {
        if (Object.keys(userSliceState.user_Auth).length) {
          setHidden(false);
          setActive("template");
        } else setOpenSignIn(true);
      }
    }
  };

  const { t } = useTranslation();
  return (
    <Row
      onClick={() => {
        NavigateObject(object, setOpen, setObject, condition);
      }}
      className={`placeHolder ${
        active === object && "selected"
      } pt-3 m-0 text-center p-0 align-items-center justify-content-center`}
    >
      <Row className="iconHolder justify-content-center align-items-center m-0 p-0">
        <img alt="navObject" className=" p-0 icon" src={src} />
      </Row>
      <p className=" mb-3 line_height_100pc mt-3 p-0">{t(text)}</p>
      <div className={`${"breaker"}`}></div>
    </Row>
  );
};

export default NavObject;
